import Util from '../../Common/Util';

/**
 * 악덕알리미 홈
 *  - 인사 첫 방문 1회
 *  - 핵심기능 아코디언 ([!]·접기)
 *  - 핵심기능 스와이프 캐러셀(터치 드래그 + 도트)
 *  - 개인 푸시 수신함 알림 피드
 */
export default class Home {
    initialize() {
        this.renderAmounts();
        this.showGreetOnce();
        this.bindFeature();
        this.bindSwipe();
        this.bindHomeSearch();
        this.bindAlerts();
        $('.b-search-card__pair').on('click', () => location.replace('/b/stats'));
        // 네이티브 동기화(alertMode+mbno)는 Sites/Devil/Bootstrap 이 모든 페이지 공통으로 처리.
    }

    /**
     * 서버가 값만 넘긴 금액 자리([data-won-compact])를 억/만/원 축약 금액으로 그린다.
     * 자리의 클래스는 그대로 두고 안을 채운다 — 스타일은 _home.scss .b-search-card__hero-num.
     */
    renderAmounts() {
        document.querySelectorAll('[data-won-compact]').forEach((el) => {
            el.innerHTML = $j.F.Devil.Render.won(el.dataset.wonCompact, { compact: true });
        });
    }

    /**
     * 홈 상단 검색 — "체불 유무 확인부터 하세요".
     * 연락처 입력 → /b/ajax/master 조회 → 매치 시 첫 업체 상세 시트, 없으면 안내.
     * (리스트 화면 이동이 아니라 즉석 조회 — List.bindSearch 와 같은 엔드포인트 재사용)
     *
     * ⚠ 개인정보: 부분 번호로 남의 업체를 캐내지 못하도록 **완전한 번호를 입력해야만** 조회한다.
     *   서버 검색은 LIKE 이지만, 완전한 번호는 다른 번호의 부분문자열이 될 수 없어
     *   완전번호로만 넘기면 사실상 정확 일치가 된다(마스킹된 응답을 비교할 필요 없음).
     *   한국 전화번호는 모두 '0' 으로 시작, 완전한 번호는 9~12자리(02 시내 9 ~ 0507 안심 12).
     */
    bindHomeSearch() {
        const $q = $('#b-home-q');
        const $go = $('#b-home-go');
        if (!$q.length) return;

        const toast = (msg) => {
            if (window.BD && typeof window.BD.toast === 'function') window.BD.toast(msg);
            else alert(msg);
        };

        const isCompletePhone = (digits) =>
            /^0\d{8,11}$/.test(digits); // 0 으로 시작 + 총 9~12자리

        // 2026-09-15 QA — 숫자가 끝없이 들어가던 것. 칠 때마다 숫자만 남기고 12자리(0505 안심번호 최장)에서 자른다.
        //   maxlength 속성은 쓰지 않는다 — '010-1234-5678' 을 붙여넣으면 하이픈까지 13글자로 세어 끝자리가 잘린다.
        //
        // 2026-10-06 상필 님 요청 — 하이픈을 자동으로 넣는다(제보 작성의 전화칸과 같은 Util.phoneNumber).
        //   숫자만 11자리가 이어지면 읽기 어렵고, 제보 화면과 보이는 모양이 달라 헷갈린다.
        //   종전에 안 넣었던 이유(아주크게에서 번호가 칸 밖으로 밀림)는 글자가 2~3자 늘어나는 것이라,
        //   밀리면 칸 안에서 가로로 스크롤될 뿐 값은 그대로다. 조회는 어차피 숫자만 떼어 보낸다(onSearch).
        const MAX_DIGITS = 12;
        $q.on('input', () => {
            const digits = ($q.val() || '').replace(/\D/g, '').slice(0, MAX_DIGITS);
            const pretty = Util.phoneNumber(digits);
            if ($q.val() !== pretty) $q.val(pretty);
        });
        // 누르면 적어 둔 번호 전체 선택 — 새 번호를 치면 바로 바뀐다(× 버튼은 칸이 좁아 아주크게에서 번호가 잘려 두지 않는다).
        //   탭하면 커서 위치가 선택을 풀어 버리므로 포커스 직후 한 박자 늦게 고른다.
        $q.on('focus', () => { if ($q.val()) setTimeout(() => $q[0].select(), 50); });

        const onSearch = () => {
            const digits = ($q.val() || '').replace(/\D/g, '');
            if (!digits) return;
            if (!isCompletePhone(digits)) {
                toast('전체 번호를 입력해주세요. (예: 01023456789)');
                return;
            }
            $.getJSON('/b/ajax/master', { keyword: digits, sort: 'all', offset: 0 }).done((res) => {
                const rows = (res && res.data) || [];
                if (rows.length && rows[0].master_num) {
                    $j.F.Devil.Master.openFull(rows[0].master_num);
                } else {
                    $j.Ui.Modal.open({
                        mode: 'sheet',
                        variant: 'devil',
                        html: '<div style="text-align:center;padding:24px 12px">'
                            + '<p style="font-size:16px;font-weight:700;color:var(--t1)">제보 내역이 없습니다</p>'
                            + '<p style="font-size:13px;color:var(--t3);line-height:1.55;margin-top:6px">'
                            + '입력하신 연락처로 접수된 제보가 없습니다.<br>제보가 없다고 안전을 보장하지는 않습니다.</p>'
                            + '</div>',
                    });
                }
            });
        };

        $go.on('click', onSearch);
        // Enter 로 조회하면 칸의 포커스를 빼 소프트 키보드를 내린다 — 키보드가 남아 결과(상세 시트)를 가렸다(2026-10-07 상필 님 QA).
        //   웹뷰·브라우저 모두 포커스가 빠지면 키보드가 내려가므로 앱(네이티브) 수정은 필요 없다.
        $q.on('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); $q.trigger('blur'); onSearch(); } });
    }


    // 개인 푸시 수신함 — 20건씩 이어 붙이는 무한스크롤 (체불 리스트 List.js 와 같은 방식 · 더보기 버튼 폴백)
    bindAlerts() {
        const $body = $('.b-alerts__body');
        const $more = $('#b-alerts-more');
        const R = $j.F.Devil.Render;
        const PAGE = 20;
        let lastId = 0;
        let done = false;
        let loading = false;
        let seq = 0;   // 처음부터 다시 받은 뒤 늦게 온 응답을 버리는 번호
        let scroll = null;

        const fetchPage = () => {
            if (loading || done) return;
            loading = true;
            const mine = ++seq;
            if (scroll) { $more.addClass('is-auto'); scroll.resume(); }   // 실패 뒤 멈춘 감시·버튼 원복
            $.getJSON('/b/ajax/alerts', { limit: PAGE, before: lastId || undefined }).done((res) => {
                if (mine !== seq) return;
                const list = (res && res.list) || [];
                if (!lastId && !list.length) $body.html('<p class="b-alerts__empty">아직 알림이 없습니다.</p>');
                else if (!lastId) $body.html(list.map((a) => R.alertCard(a)).join(''));
                else $body.append(list.map((a) => R.alertCard(a)).join(''));
                if (list.length) lastId = list[list.length - 1].id;
                done = list.length < PAGE;
                $more.prop('hidden', done);
                loading = false;
                // 감시를 다시 건다 — 붙인 뒤에도 칸이 화면 안이면 교차 변화가 없어 다음 쪽이 안 불린다
                if (scroll && !done) { scroll.pause(); scroll.resume(); }
            }).fail(() => {
                if (mine !== seq) return;
                loading = false;
                // 실패 — 칸을 버튼으로 바꿔 손으로 다시 시도하게 한다. 감시를 켜 두면 보이는 버튼이 실패를 되풀이한다
                if (scroll) scroll.pause();
                $more.removeClass('is-auto').prop('hidden', false);
            });
        };
        const load = () => {   // 내제보건에서 상태가 바뀌면 처음부터 다시
            lastId = 0;
            done = false;
            loading = false;
            fetchPage();
        };

        $('#b-alerts-more-btn').on('click', fetchPage);
        scroll = $j.Ui.InfiniteScroll.attach($more[0], { root: $body.closest('.b-scroll')[0], onLoad: fetchPage });
        load();

        // 알림 클릭 → 내 제보(report_num) 면 내제보건 상세 BS, 그 외(통화경고 등) 면 악덕 상세 풀페이지.
        // (알림상세는 대표 요청으로 바텀시트 대신 불투명 풀페이지 — 뒤 배경 비침 제거)
        $body.on('click', '.b-alert', function () {
            const reportNum = $(this).data('report-num');
            const masterNum = $(this).data('master-num');
            if (reportNum) {
                $j.F.Devil.MyReport.open(reportNum, load); // 내제보건 카드 클릭과 동일
            } else if (masterNum) {
                $j.F.Devil.Master.openFull(masterNum);     // 풀페이지 상세
            }
        });
    }

    // 인사 — 이 기기에서 그 회원의 첫 방문에만 보인다. 대리로그인·기기 변경 시 그 기기 기준으로 다시 1번
    showGreetOnce() {
        const $top = $('.b-home__top');
        const key = `b:home:greetSeen:${$top.data('mb')}`;
        if ($j.Common.Store.local.get(key) === '1') return;
        $top.prop('hidden', false);
        $j.Common.Store.local.set(key, '1');
    }

    // 핵심기능 아코디언 — 접은 적이 없으면 펼쳐 보이고, 제목 옆 [!] 와 [접기] 로 여닫는다. 상태는 기기에 남는다
    bindFeature() {
        const KEY = 'b_feat_open';   // '0' 접힘 · 그 외 펼침
        const $card = $('.b-feat');
        const $help = $('.b-search-card__feat');
        const set = (open) => {
            $card.toggleClass('is-open', open);
            $help.attr('aria-expanded', open ? 'true' : 'false');
        };

        // 저장된 상태 복원은 애니메이션 없이
        $card.addClass('b-feat--no-anim');
        set($j.Common.Store.local.get(KEY) !== '0');
        if ($card[0]) $card[0].offsetHeight; // force reflow
        $card.removeClass('b-feat--no-anim');

        const toggle = (open) => {
            $j.Common.Store.local.set(KEY, open ? '1' : '0');
            set(open);
        };
        $help.on('click', () => toggle(!$card.hasClass('is-open')));
        $card.find('.b-feat__fold').on('click', () => toggle(false));
    }

    bindSwipe() {
        // 핵심기능 캐러셀 — 공용 스와이프 모듈 (.b-feat 안의 track/dot 자동 탐색)
        $j.Ui.Swipe.init('.b-feat');
    }
}
